const faqs = [
  {
    q: '妖精动漫网需要注册才能看漫画吗？',
    a: '不需要注册！妖精动漫平台所有漫画资源均免费开放，无需注册登录即可直接在线阅读。打开网站选择你喜欢的作品，即刻享受流畅的下拉式阅读体验。我们坚持零门槛访问，让每一位漫画爱好者都能轻松畅读。',
  },
  {
    q: '妖精动漫支持手机端阅读吗？',
    a: '完全支持。妖精动漫网站采用响应式设计，在手机、平板、电脑上均能完美适配。在手机浏览器打开即可享受专为移动端优化的下拉式阅读，无需下载额外应用，随时随地追更你喜爱的韩漫、日漫和国漫。',
  },
  {
    q: '妖精动漫的更新频率是怎样的？',
    a: '妖精动漫网保持高频更新节奏，热门连载作品每日同步更新，新番上架及时跟进。韩漫、日漫、国漫均有专属更新排期，确保读者能在第一时间看到最新话。遇到节假日或特殊情况会提前公告，绝不无故断更。',
  },
  {
    q: '妖精动漫是否完全免费？',
    a: '是的，妖精动漫平台所有漫画资源完全免费，不设任何付费墙或会员限制。我们致力于打造一个开放、免费的中文漫画阅读社区，让每一位热爱漫画的读者都能无负担地享受阅读乐趣。',
  },
  {
    q: '如何在妖精动漫收藏喜欢的作品？',
    a: '点击任意作品进入详情页，即可看到收藏按钮。收藏后可在个人书架中快速找到已收藏的作品，方便随时继续阅读。追更收藏一站搞定，再也不用在多个网站之间切换寻找更新进度了。',
  },
  {
    q: '妖精动漫支持哪些类型的漫画？',
    a: '妖精动漫网全面覆盖韩漫、日漫、国漫三大品类，类型横跨热血格斗、恋爱甜宠、奇幻冒险、悬疑推理、搞笑日常、治愈温情、武侠古风、校园青春、科幻未来等全品类。无论你偏爱哪种风格，都能在这里找到心头好。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[480px] mx-auto">
            关于妖精动漫平台的使用疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 gap-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 hover:border-accent-200">
              <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-800 list-none">
                <h3 className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</h3>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed border-t border-background-100 pt-3">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}